// ─── Award badges & review-platform slides ────────────────────────────────────
// Centralised constants for trust signals displayed across the site (blog
// sidebars, case studies, landing pages, footers, etc.).
// Keep asset paths here — never inline CDN URLs in component files.

import {cdnUrl} from '@/util/cdnImage';

/** Review-platform rating badges (Clutch, GoodFirms, Top Developers). */
export const REVIEW_SLIDES = [
    {platform: 'Clutch', src: cdnUrl('blog/clutch-rating-badge.webp'), href: 'https://clutch.co/profile/debut-infotech'},
    {platform: 'GoodFirms', src: cdnUrl('blog/goodfirms-rating-badge.webp'), href: 'https://www.goodfirms.co/company/debut-infotech'},
    {
        platform: 'Top Developers',
        src: cdnUrl('blog/top-developer-rating-badge.webp'),
        href: 'https://www.topdevelopers.co/profile/debut-infotech'
    }
];

/** Award/recognition badges from external directories. */
// 400×400 originals (255×255 for TechBehemoths) — sharper than the 160×160
// "-2026"/"-uk" re-exports of the same artwork, at the cost of slightly older
// baked-in year/wording on some badges.
export const BADGE_SLIDES = [
    {src: cdnUrl('home-page-new/web3-developement-clutch.webp'), alt: 'Clutch Top Web3 Development Company'},
    {src: cdnUrl('home-page-new/blockchain-technology-companies-goodfirms.webp'), alt: 'GoodFirms Top Blockchain Development'},
    {src: cdnUrl('home-page-new/Rightfirms-software-development.webp'), alt: 'RightFirms Software Development'},
    {src: cdnUrl('home-page-new/Selectedfirms-top-ai-developement.webp'), alt: 'SelectedFirms Top AI Development'},
    {src: cdnUrl('ai-copliot-development-new/techbehmoths-award-ai-2024 2.webp'), alt: 'Techbehmoths Award AI'},
    {src: cdnUrl('home-page-new/techviewer-top-software-developers.webp'), alt: 'Techreviewer Top Software Developers'}
];

/** A badge card in the Badges & Recognition carousel (`CertificationSection`). */
export interface AwardCard {
    src: string;
    alt: string;
    name: string;
    category: string;
    region: string;
    year: string;
}

// BADGE_SLIDES only carries `src`/`alt`; the card also needs a short name, a
// category caption and a year, so that's layered on here rather than in the
// shared constant (which other, non-card consumers use as-is).
export const AWARD_CARDS: AwardCard[] = [
    {...BADGE_SLIDES[0], name: 'Clutch', category: 'Top Web3 Development Company', region: 'United Kingdom', year: '2026'},
    {...BADGE_SLIDES[1], name: 'GoodFirms', category: 'Top Blockchain Development Companies', region: 'Global', year: '2026'},
    {...BADGE_SLIDES[2], name: 'RightFirms', category: 'Software Development', region: 'Global', year: '2026'},
    {...BADGE_SLIDES[3], name: 'SelectedFirms', category: 'Top AI Development Company', region: 'Global', year: '2026'},
    {...BADGE_SLIDES[4], name: 'TechBehemoths', category: 'AI Excellence Award', region: 'United States', year: '2025'},
    {...BADGE_SLIDES[5], name: 'TechReviewer', category: 'Top Software Developers', region: 'Global', year: '2026'},
    // Kept here rather than in BADGE_SLIDES, which other consumers (e.g. the blog
    // sidebar marquee) render as-is.
    {
        src: cdnUrl('home-page-updated-assets/itrate-top-web-development-company.webp'),
        alt: 'ITRate Top Web Development Company',
        name: 'ITRate',
        category: 'Top Web Development Company',
        region: 'Global',
        year: '2026'
    },
    {
        src: cdnUrl('home-page-updated-assets/mobileappdaily-top-app-development-companies-in-chicago.webp'),
        alt: 'MobileAppDaily Top App Development Companies in Chicago',
        name: 'MobileAppDaily',
        category: 'Top App Development Companies in Chicago',
        region: 'United States',
        year: '2026'
    },
    {
        src: cdnUrl('home-page-updated-assets/rightfirms-blockchain-technologies.webp'),
        alt: 'RightFirms Blockchain Technologies',
        name: 'RightFirms',
        category: 'Blockchain Technologies',
        region: 'Global',
        year: '2026'
    },
    {
        src: cdnUrl('home-page-updated-assets/selectedfirms-top-healthcare-software-development-company.webp'),
        alt: 'SelectedFirms Top Healthcare Software Development Company',
        name: 'SelectedFirms',
        category: 'Top Healthcare Software Development Company',
        region: 'Global',
        year: '2026'
    }
];
